import cn from 'classnames';
import { CSSProperties, ReactNode } from 'react';
import { type JSX } from 'react';
import styles from './box.module.scss';
type TBoxProps = {
  style?: CSSProperties;
  children: ReactNode;
  className?: string;
};
export const Box = ({
  style,
  children,
  className,
  ...props
}: TBoxProps): JSX.Element => {
  return (
    <div style={style} className={cn(className, styles.box)} {...props}>
      {children}
    </div>
  );
};
